import { useState, useRef, useEffect } from "react";

export function useLineCount(text: string): [React.RefObject<HTMLSpanElement>, number] {
  const textRef = useRef<HTMLSpanElement | null>(null);
  const [lineCount, setLineCount] = useState(0);

  useEffect(() => {
    if (textRef.current) {
      const elementHeight = textRef.current.offsetHeight;
      const lineHeight = parseInt(getComputedStyle(textRef.current).lineHeight, 10);

      setLineCount(Math.round(elementHeight / lineHeight));
    }
  }, [text]);

  return [textRef, lineCount];
}
